export * from './contracts';
export var ChainId;
(function (ChainId) {
    ChainId[ChainId["ETHEREUM"] = 1] = "ETHEREUM";
    ChainId[ChainId["SEPOLIA"] = 11155111] = "SEPOLIA";
    ChainId[ChainId["ZK_EVM"] = 388] = "ZK_EVM";
    ChainId[ChainId["ZK_EVM_TEST"] = 240] = "ZK_EVM_TEST";
    ChainId[ChainId["CRONOS_EVM_MAINNET"] = 25] = "CRONOS_EVM_MAINNET";
    ChainId[ChainId["CRONOS_EVM_TESTNET"] = 338] = "CRONOS_EVM_TESTNET";
})(ChainId || (ChainId = {}));
export const L1_CHAIN_IDS = [ChainId.ETHEREUM, ChainId.SEPOLIA];
export const CRONOS_EVM_CHAIN_IDS = [
    ChainId.CRONOS_EVM_MAINNET,
    ChainId.CRONOS_EVM_TESTNET,
];
export const L2_CHAIN_IDS = [ChainId.ZK_EVM, ChainId.ZK_EVM_TEST];
export function isChainIdL1(chainId) {
    return L1_CHAIN_IDS.includes(chainId);
}
export function isChainIdL2(chainId) {
    return L2_CHAIN_IDS.includes(chainId);
}
export function isChainIdCronosEvm(chainId) {
    return CRONOS_EVM_CHAIN_IDS.includes(chainId);
}
const chainIdSet = new Set([
    ...L1_CHAIN_IDS,
    ...L2_CHAIN_IDS,
    ...CRONOS_EVM_CHAIN_IDS,
]);
export const isChainId = (chainId) => chainIdSet.has(chainId);
export var ChainLayer;
(function (ChainLayer) {
    ChainLayer["L1"] = "L1";
    ChainLayer["L2"] = "L2";
    ChainLayer["CronosEvm"] = "CronosEvm";
})(ChainLayer || (ChainLayer = {}));
export class FromBalanceTooLowError extends Error {
    constructor(amount, message = 'WCRO balance too low') {
        super(message);
        this.name = 'FromBalanceTooLowError';
        this.amount = amount;
    }
}
/**
 * identifier of tokens in YbUsdBridge contract
 */
export var YbTokenBridgeTokenType;
(function (YbTokenBridgeTokenType) {
    YbTokenBridgeTokenType[YbTokenBridgeTokenType["ETH"] = -1] = "ETH";
    YbTokenBridgeTokenType[YbTokenBridgeTokenType["DAI"] = 0] = "DAI";
    YbTokenBridgeTokenType[YbTokenBridgeTokenType["USDC"] = 1] = "USDC";
    YbTokenBridgeTokenType[YbTokenBridgeTokenType["USDT"] = 2] = "USDT";
})(YbTokenBridgeTokenType || (YbTokenBridgeTokenType = {}));
